export const ROUTES = {
  COMPETITOR_INSIGHTS: "competitor-insights",
  COMPETITOR_INSIGHTS_V2: "v2/competitor-insights",
  PRESS_DIGEST: "press-digest",
  PRESS_DIGEST_V2: "v2/press-digest",
  PRODUCT_INSIGHTS: "product-trends",
  AI_REPORTS: "competitor-reports",
  PRODUCT_COMPARISON: "product-showdown",
  PRICING_ANALYTICS: "pricing-analytics",
  RD_LANDSCAPE: "rd-landscape",
  EXPANSION_TRENDS: "expansion-trends",
};

export const PAGE_SELECTOR_CONFIG = {
  [ROUTES.COMPETITOR_INSIGHTS]: {
    showCompetitorSelector: true,
    showDateRangeSelector: true,
    showPressSelector: false,
    customCompetitorOptions: [],
  },
  [ROUTES.COMPETITOR_INSIGHTS_V2]: {
    showCompetitorSelector: true,
    showDateRangeSelector: false,
    showPressSelector: false,
    customCompetitorOptions: [{ id: "all_competitors", name: "All Competitors" }],
  },
  [ROUTES.PRODUCT_INSIGHTS]: {
    showCompetitorSelector: true,
    showDateRangeSelector: true,
    showPressSelector: false,
    customCompetitorOptions: [],
  },
  [ROUTES.AI_REPORTS]: {
    showCompetitorSelector: true,
    showDateRangeSelector: false,
    showPressSelector: false,
    customCompetitorOptions: [{ id: "market_overview", name: "Market Report" }],
  },
  [ROUTES.RD_LANDSCAPE]: {
    showCompetitorSelector: true,
    useRdCompetitorContext: true,
    showConditionSelector: true,
    showDateRangeSelector: false,
    showPressSelector: false,
    customCompetitorOptions: [{ id: "market", name: "All Competitors" }],
  },
  [ROUTES.PRODUCT_COMPARISON]: {
    showAnchorSelector: true,
    showCompetitorSelector: true,
    useShowdownCompetitorContext: true,
    showDateRangeSelector: false,
    showPressSelector: false,
  },
  [ROUTES.PRICING_ANALYTICS]: {
    showProductSelectors: true,
    showDateRangeSelector: false,
    showPressSelector: false,
  },
  [ROUTES.PRESS_DIGEST]: {
    showPressSelector: true,
    showDateRangeSelector: true,
    showCompetitorSelector: false,
  },
  [ROUTES.PRESS_DIGEST_V2]: {
    showPressSelector: false,
    showDateRangeSelector: false,
    showCompetitorSelector: false,
  },
  [ROUTES.EXPANSION_TRENDS]: {
    showCompetitorSelector: true,
    showDateRangeSelector: true,
    showPressSelector: false,
    customCompetitorOptions: [{ id: "market_trends", name: "Market Trends" }],
  },
};

export const DEFAULT_PRODUCTS = {
  OUR_PRODUCTS: [
    { id: "our-1", name: "WEB 17 Embolization System" },
    { id: "our-2", name: "WEB 17 XT" },
  ],
  COMPETING_PRODUCTS: [
    { id: "comp-1", name: "Artisse Intrasaccular Device" },
    { id: "comp-2", name: "Contour Neurovascular System" },
  ],
};
